<template>
    <div class="form-container">
        <h2>Assign Students to Group</h2>
        <hr>

        <label>Select Group <span class="required">*</span></label>
        <select v-model="selectedGroup" class="form-control" required @change="fetchAssignedStudents">
            <option value="0">Select</option>
            <option v-for="group in groups" :key="group.id" :value="group.id">{{ group.name }}</option>
        </select>

        <label>Search Students</label>
        <input type="text" v-model="searchQuery" placeholder="Search students..." class="form-control">

        <div class="student-list">
            <table class="table table-bordered">
                <thead>
                    <tr>
                        <th>Select</th>
                        <th>Name</th>
                        <th>Email</th>
                    </tr>
                </thead>
                <tbody>
                    <tr v-for="student in filteredStudents" :key="student.id">
                        <td>
                            <input type="checkbox" v-model="selectedStudents" :value="student.id">
                        </td>
                        <td>{{ student.user.name }}</td>
                        <td>{{ student.user.email }}</td>
                    </tr>
                </tbody>
            </table>
        </div>

        <div class="btn-group">
            <button type="button" class="btn btn-sm btn-primary" @click="assignStudents">Save</button>
            <button type="button" class="btn btn-sm cancel-btn"
                @click="$router.push('/dashboard/groups')">Cancel</button>
        </div>
    </div>
</template>

<script>
export default {
    data() {
        return {
            groups: [],
            students: [],
            selectedGroup: this.$route.params.id || '0',
            selectedStudents: [],
            searchQuery: ''
        };
    },
    computed: {
        filteredStudents() {
            return this.students.filter(student =>
                student.user.name.toLowerCase().includes(this.searchQuery.toLowerCase()) ||
                student.user.email.toLowerCase().includes(this.searchQuery.toLowerCase())
            );
        }
    },
    methods: {
        async fetchGroups() {
            const response = await this.$api.get('/groups');
            this.groups = response.data;
        },
        async fetchStudents() {
            const response = await this.$api.get('/students');
            this.students = response.data;
        },
        async fetchAssignedStudents() {
            if (this.selectedGroup && this.selectedGroup !== '0') {
                try {
                    const response = await this.$api.get(`/groups/${this.selectedGroup}/students`);
                    this.selectedStudents = response.data.map(student => student.student_id);

                } catch (error) {
                    console.error('Error fetching assigned students:', error);
                }
            }
        },
        async assignStudents() {
            if (!this.selectedGroup || this.selectedStudents.length === 0) {
                alert('Please select a group and at least one student.');
                return;
            }
            try {
                await this.$api.post(`/groups/${this.selectedGroup}/assign-students`, {
                    students: this.selectedStudents
                });

                this.$router.push('/dashboard/groups');
            } catch (error) {
                console.error('Error assigning students:', error);
            }
        }
    },
    mounted() {
        this.fetchGroups();
        this.fetchStudents();
        this.fetchAssignedStudents();
    }
};
</script>

<style scoped>
.form-container {
    padding: 20px;
    background: white;
    border-radius: 10px;
    box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);
}

.student-list {
    margin-top: 20px;
    max-height: 300px;
    overflow-y: auto;
}
</style>
